import options from './options';
import packages from './packages';
import settings from './settings';

const root = {
	options,
	packages,
	settings
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js